import { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { rltRendimentoAluno, rltBoletimAluno } from './api-relatorio';
import CircularProgress from '@mui/material/CircularProgress';
import { Link } from 'react-router-dom';
import { findByTurma } from "../AlunoTurma/api-aluno-turma";
import TurmaComboBox from '../Turma/UI/TurmaComboBox';
import BimestreComboBox from '../Bimestre/UI/BimestreComboBox';
import AlunoTurmaComboBox from '../AlunoTurma/UI/AlunoTurmaComboBox';
import { useNavigate } from 'react-router-dom';
import { errorMessage } from '../../util/ConfirmAlertUtil';
import GridPaper from '../../util/GridPaper';
import { Grid } from '@mui/material';

const useStyles = makeStyles(theme => ({
    form: {
        width: '100%', // Fix IE 11 issue.
    },
    title: {
        paddingTop: '20px;'
    },
    submit: {
        // margin: theme.spacing(3, 0, 2),
    },
    loading: {
        margin: '20px'
    }
}));

export default function RelatorioAlunoBimestreForm({ turmas }) {
    const classes = useStyles();
    const [relatorioAluno, setRelatorioAluno] = useState({
        numeroBimestre: 1
    });
    const [loading, setLoading] = useState(false);
    const [turma, setTurma] = useState();
    const [alunosTurma, setAlunosTurma] = useState([]);
    const history = useNavigate();



    useEffect(() => {
        if (turma) {
            findByTurma(turma.codigo).then((data) => {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    setAlunosTurma(data);
                }
            });
        }

    }, [turma]);

    const handleRendimentoEscolar = () => {
        setLoading(true);
        rltRendimentoAluno(relatorioAluno).then(data => {
            if (data) {
                var file = new Blob([data], { type: 'application/pdf' });
                var fileURL = URL.createObjectURL(file);
                window.open(fileURL);
                setLoading(false);
            }
        })
    }

    const handleRendimentoEscolarWeb = () => {
        if (!relatorioAluno.alunoTurma) {
            handleErrorSelecionarAluno();
        } else {
            history("/relatorio-rendimento-escolar-web", {
                state: {
                    numeroBimestre: relatorioAluno.numeroBimestre,
                    codAlunosTurmas: relatorioAluno.alunoTurma ? [relatorioAluno.alunoTurma.codigo] : []
                }
            })
        }

    }

    const handleErrorSelecionarAluno = () => {
        errorMessage("Selecione um Aluno.");
    }

    const handleBoletimEscolar = () => {
        setLoading(true);
        rltBoletimAluno(relatorioAluno).then(data => {
            if (data) {
                var file = new Blob([data], { type: 'application/pdf' });
                var fileURL = URL.createObjectURL(file);
                window.open(fileURL);
                setLoading(false);
            }
        })
    }

    const handleBimestreChange = (event) => {
        setRelatorioAluno({
            ...relatorioAluno,
            numeroBimestre: event.target.value
        });
    }

    const handleTurmaChange = (event) => {
        setRelatorioAluno({
            ...relatorioAluno,
            alunoTurma: null
        });
        setTurma(turmas.find(t => t.codigo === event.target.value));
    }

    const handleAlunoTurmaChange = (event) => {
        setRelatorioAluno({
            ...relatorioAluno,
            alunoTurma: {
                codigo: event.target.value
            }
        });
    }

    return (
        <Container  >
            <Typography className={classes.title} variant="body1">
                Por Aluno e Bimestre
            </Typography>
            <GridPaper container justifyContent='center' spacing={3}>
                <Grid size={12}>
                    <TurmaComboBox
                        turmas={turmas}
                        turma={turma}
                        handleTurmaChange={handleTurmaChange}
                    />
                </Grid>

                {turma &&
                    <Grid size={12}>
                        <AlunoTurmaComboBox
                            alunosTurma={alunosTurma}
                            alunoTurma={relatorioAluno.alunoTurma}
                            handleAlunoTurmaChange={handleAlunoTurmaChange}
                        />

                    </Grid>
                }


                {turma && relatorioAluno.alunoTurma &&
                    <Grid size={12}>
                        <BimestreComboBox
                            numeroBimestre={relatorioAluno.numeroBimestre}
                            handleBimestreChange={handleBimestreChange}
                        />
                    </Grid>
                }


                {loading ?
                    <Grid size={12}>
                        <CircularProgress
                            className={classes.loading}
                            color="primary"
                        />
                    </Grid>
                    :
                    <>
                        <Grid>
                            <Button
                                component={Link}
                                to={{
                                    pathname: '/relatorio-ata-final-web',

                                }}
                                state={{
                                    codAlunoTurma: relatorioAluno.alunoTurma ? relatorioAluno.alunoTurma.codigo : null
                                }}
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}>
                                Ata Final Web
                            </Button>
                        </Grid>
                        <Grid>

                            <Button
                                component={Link}
                                to={{
                                    pathname: '/relatorio-boletim-web',

                                }}
                                state={{
                                    numeroBimestre: relatorioAluno.numeroBimestre,
                                    codAlunosTurmas: relatorioAluno.alunoTurma ? [relatorioAluno.alunoTurma.codigo] : []
                                }}
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}>
                                Boletim Web
                            </Button>
                        </Grid>
                        <Grid>
                            <Button
                                onClick={handleBoletimEscolar}
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}>
                                Boletim PDF (Habilitar Pop Up)
                            </Button>

                        </Grid>
                        <Grid>

                            <Button
                                onClick={handleRendimentoEscolar}
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}>
                                Rendimento Escolar
                            </Button>
                        </Grid>
                        <Grid>
                            <Button
                                onClick={handleRendimentoEscolarWeb}
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}>
                                Rendimento Escolar Web
                            </Button>
                        </Grid>

                    </>
                }
            </GridPaper>

        </Container>
    );
}